import { AppRemixIcon } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import SelectPlants from '../../../../components/form/Selects/SelectPlants';
import AppInput from '../../../../components/form/AppInput';

const Report16Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <SelectPlants
            type="userPlants"
            format="m"
            value={values.customPlants}
            onHandleChange={(opt) => {
              handleOnSetFieldValue('customPlants', opt);
            }}
            isMulti
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AppInput
            title={<Translator file="module-intelligence" name="phase" />}
            icon={<AppRemixIcon icon="chat-quote" />}
            value={values.stage || ''}
            onChange={(opt) => handleOnSetFieldValue('stage', opt)}
            isClearable
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AppInput
            title={<Translator file="module-intelligence" name="area" />}
            icon={<AppRemixIcon icon="chat-quote" />}
            value={values.area || ''}
            onChange={(opt) => handleOnSetFieldValue('area', opt)}
            isClearable
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={
                  !values.customPlants || values.customPlants.length === 0
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report16Options;
